<template>
  <div class="min-h-screen ml-0 w-full lg:mr-3">
    <!-- Add position -->
    <add-position
      :showAddPosition="showAddPosition"
      @close="handleCloseAddPosition"
    ></add-position>
    <!-- List of applications -->
    <div v-if="!showApplicants" class="bg-white m-3 rounded-md">
      <div
        class="border-b-0.5 flex flex-wrap lg:gap-0 gap-5 justify-between items-center p-3"
      >
        <p class="text-sm font-semibold">Job Applications</p>
        <div class="flex flex-wrap lg:gap-10 gap-5">
          <div class="flex gap-4">
            <select class="rounded-xl w-full px-4 py-1 bg-gray-200">
              <option>Job Position</option>
            </select>
            <select class="rounded-xl w-full px-4 bg-gray-200">
              <option>Job Type</option>
            </select>
          </div>
          <button
            @click="addPosition"
            class="bg-primary text-white rounded-full px-3 py-1 text-sm"
          >
            Add Position
          </button>
        </div>
      </div>
      <div class="p-2">
        <ve-table
          v-if="tableData.length > 0"
          :columns="columns"
          :table-data="tableData"
        />
        <p v-else class="text-center text-gray-500">No Data</p>
      </div>
      <ve-contextmenu eventTarget="#contextmenu-target" :options="options" />
    </div>
    <!-- List of applicants -->
    <div v-else>
      <applications-per-position
        @close="handleCloseApplicationsPerPosition"
      ></applications-per-position>
    </div>
  </div>
</template>

<script>
import ApplicationsPerPosition from "@/components/recruitment/applicationsPerPosition.vue";
import AddPosition from "@/components/recruitment/addPosition.vue";
export default {
  name: "Recruitment",
  components: { ApplicationsPerPosition, AddPosition },
  data() {
    return {
      showApplicants: false,
      showAddPosition: false,
      columns: [
        {
          field: "",
          key: "numbering",
          title: "#",
          width: 50,
          align: "center",
          renderBodyCell: ({ rowIndex }) => {
            return ++rowIndex;
          },
        },
        {
          field: "Position",
          key: "a",
          title: "Position",
          renderBodyCell: ({ row }) => {
            return (
              <p
                on-click={() => this.viewApplicants()}
                class="text-blue-500 cursor-pointer"
              >
                {row.Position}
              </p>
            );
          },
        },
        { field: "No", key: "b", title: "No of Applicants" },
        { field: "Location", key: "c", title: "Location" },
        {
          field: "Date",
          key: "x",
          title: "Date Created",
        },
        { field: "Manager", key: "d", title: "Hiring Manager" },

        {
          field: "Action",
          key: "f",
          title: "Action",
          renderBodyCell: () => {
            return (
              <p
                id="contextmenu-target"
                ref="contextmenuTargetRef"
                class="cursor-pointer transform rotate-90 font-bold"
              >
                &#8230;
              </p>
            );
          },
        },
      ],
      tableData: [],
      eventTarget: "",
      options: [
        [
          {
            label: "menu1",
            type: "menu1-type",
          },
          {
            label: "menu2",
            type: "menu2-type",
            children: [
              {
                label: "menu2-1",
                type: "menu2-1-type",
              },
              {
                label: "menu2-2",
                type: "menu2-2-type",
              },
            ],
          },
          {
            type: "SEPARATOR",
          },
          {
            label: "menu3",
            type: "menu3-type",
          },
        ],
      ],
    };
  },
  mounted() {
    this.eventTarget = this.$refs["contextmenuTargetRef"];
  },
  methods: {
    viewApplicants() {
      this.showApplicants = true;
    },
    addPosition() {
      this.showAddPosition = true;
    },
    handleCloseApplicationsPerPosition() {
      this.showApplicants = false;
    },
    handleCloseAddPosition() {
      this.showAddPosition = false;
    },
  },
};
</script>
